import React from 'react';

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.125rem"
      height="1.125rem"
      viewBox="0 0 14 14"
      version="1.1">
      <title>noun-open-3560915</title>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="#8A94A6"
        fillRule="evenodd">
        <g
          id="3.5.2---KB---specific-doc-index"
          transform="translate(-1354, -162)"
          fill="##8A94A6"
          fillRule="nonzero">
          <g id="noun-open-3560915" transform="translate(1353.9993, 162)">
            <path
              d="M11.1483413,12.4444444 L5.96315613,12.4444444 L5.96315613,14 L11.1483413,14 C12.7233756,14 14.0001932,12.7231824 14.0001932,11.1481481 L14.0001932,2.85185185 C14.0001932,1.27681757 12.7233756,0 11.1483413,0 L2.85204501,0 C1.27701073,0 0.000193162896,1.27681757 0.000193162896,2.85185185 L0.000193162896,10.7177778 C-0.0105987798,11.4599543 0.431651997,12.1338951 1.11681045,12.4193778 C1.8019689,12.7048605 2.59191408,12.5443347 3.11130427,12.0140741 L8.29648946,6.80296296 L8.29648946,9.85185185 L9.85204501,9.85185185 L9.85204501,4.92592593 C9.85204501,4.49637112 9.50382204,4.14814815 9.07426724,4.14814815 L4.14834131,4.14814815 L4.14834131,5.7037037 L7.1972302,5.7037037 L2.01204501,10.9018519 C1.93972903,10.9869313 1.82106294,11.0161515 1.71751073,10.9743776 C1.61395853,10.9326037 1.54878558,10.8292212 1.55574872,10.7177778 L1.55574872,2.85185185 C1.55574872,2.13592718 2.13612034,1.55555556 2.85204501,1.55555556 L11.1483413,1.55555556 C11.864266,1.55555556 12.4446376,2.13592718 12.4446376,2.85185185 L12.4446376,11.1481481 C12.4446376,11.8640728 11.864266,12.4444444 11.1483413,12.4444444 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
